import { EmptyComponent } from '@/router/modules/empty'

export default [
  {
    path: 'global',
    name: 'report sale global',
    component: () => import('@/views/app/report-sale/global/page-list.vue'),
    meta: { title: 'Laporan Penjualan Global' },
  },
  {
    path: 'rekap',
    name: 'report sale summary',
    component: () => import('@/views/app/report-sale/summary/page-list.vue'),
    meta: { title: 'Laporan Rekap Penjualan' },
  },
  {
    path: 'per-cabang',
    name: 'report sale by branch',
    component: () => import('@/views/app/report-sale/by-branch/page-list.vue'),
    meta: { title: 'Laporan Data Penjualan Per Cabang' },
  },
  {
    path: 'per-nota',
    name: 'report sale by nota',
    component: () => import('@/views/app/report-sale/by-nota/page-list.vue'),
    meta: { title: 'Laporan Penjualan Per Nota' },
  },
  {
    path: 'per-nota-item',
    name: 'report sale by nota item',
    component: () => import('@/views/app/report-sale/by-nota-item/page-list.vue'),
    meta: { title: 'Laporan Penjualan Per Nota Item' },
  },
  {
    path: 'per-nota-total',
    name: 'report sale by nota total',
    component: () => import('@/views/app/report-sale/by-nota-total/page-list.vue'),
    meta: { title: 'Laporan Penjualan Per Nota Total' },
  },
  {
    path: 'per-produk',
    name: 'report sale by product',
    component: () => import('@/views/app/report-sale/by-product/page-list.vue'),
    meta: { title: 'Laporan Penjualan Per Produk' },
  },
  {
    path: 'per-grup-produk',
    name: 'report sale by product group',
    component: () => import('@/views/app/report-sale/by-product-group/page-list.vue'),
    meta: { title: 'Laporan Penjualan Per Grup Produk' },
  },
  {
    path: 'per-edc',
    name: 'report sale by edc',
    component: () => import('@/views/app/report-sale/by-edc/page-list.vue'),
    meta: { title: 'Laporan Penjualan Per EDC' },
  },
  {
    path: 'retur',
    name: 'report sale return',
    component: EmptyComponent,
    // component: () => import('@/views/app/report-sale/return/page-list.vue'),
    meta: { title: 'Laporan Retur Penjualan' },
  },
  {
    path: 'produk-terlaris',
    name: 'report sale best selling product',
    component: () => import('@/views/app/report-sale/product-best-selling/page-list.vue'),
    meta: { title: 'Laporan Produk Terlaris' },
  },
]
